import WarningIcon from "@mui/icons-material/Warning";
import CenteredWrapper from "../../../../components/CenteredWrapper";
import { STRINGS_EN } from "../../../../constant";
import { keys } from "../../../../constant/keyConfig";
import { useUserContext } from "../../../../context/userGetContext";
import { getItem } from "../../../../utils/localStorage";
import AddAccount from "../AddAccount";
import ConcurrentWarning from "../ConcurrentWarning";

function AddFromStorage() {
  const { updateTeamsContext } = useUserContext();

  const contextInfo = getItem(keys.TEAMS_CONTEXT_KEY);
  const aadObjectId = contextInfo?.aadObjectId;
  if (contextInfo && aadObjectId) {
    updateTeamsContext(contextInfo);

    return (
      <CenteredWrapper>
        <AddAccount />
      </CenteredWrapper>
    );
  }

  return (
    <ConcurrentWarning
      message={STRINGS_EN.MST_unable_to_find_zycus_acc}
      notContactUs={true}
      iconName={<WarningIcon sx={{ fontSize: 50, color: "#f44336" }} />}
    />
  );
}

export default AddFromStorage;
